import { Navigate, Outlet } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';
import Loader from '../component/Loader';
import { useAuth } from '../utils/AuthContext';

const ModuleRoute = ({ module, children }) => {
  const { cargando } = useAuth();
  const { can, firstAllowedPath } = usePermissions();

  if (cargando) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );
  }

  if (!can(module)) {
    return <Navigate to={firstAllowedPath} replace />;
  }

  return children || <Outlet />;
};

export default ModuleRoute;
